// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"238bed25","455":"276dbd60","644":"ac812f55"}[chunkId] + ".chunk.js";
};